// ======================================================================
// FILE:
// src/modules/finance/routes/FinanceRoutes.js
//
// MODULE:
// Finance & Accounts Management System
//
// PURPOSE:
// Defines all Finance module routes.
// ======================================================================

import React from "react";

import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import FinanceLayout
  from "../FinanceLayout";

import FinanceDashboardPage
  from "../dashboard/pages/FinanceDashboardPage";

import ManualJournalListPage
  from "../transactions/manual_journal/pages/JournalListPage";

import JournalCreatePage
  from "../transactions/manual_journal/pages/JournalCreatePage";

import JournalViewPage
  from "../transactions/manual_journal/pages/JournalViewPage";

import JournalEditPage
  from "../transactions/manual_journal/pages/JournalEditPage";

import GeneralLedgerPage
    from "../reports/general_ledger/pages/GeneralLedgerPage";

import TrialBalancePage
from "../reports/trial_balance/pages/TrialBalancePage";

import ProfitLossPage
from "../reports/profit_loss/pages/ProfitLossPage";

import BalanceSheetPage
    from "../reports/balance_sheet/pages/BalanceSheetPage";

import CashFlowPage
    from "../reports/cash_flow/pages/CashFlowPage";

import PaymentVoucherListPage
  from "../transactions/payment_voucher/pages/PaymentVoucherListPage";

import PaymentVoucherCreatePage
  from "../transactions/payment_voucher/pages/PaymentVoucherCreatePage";

import PaymentVoucherViewPage
    from "../transactions/payment_voucher/pages/PaymentVoucherViewPage";

import PaymentVoucherEditPage
    from "../transactions/payment_voucher/pages/PaymentVoucherEditPage";    

import ReceiptVoucherCreatePage
    from "../transactions/receipt_voucher/pages/ReceiptVoucherCreatePage";

import ReceiptVoucherListPage
    from "../transactions/receipt_voucher/pages/ReceiptVoucherListPage";

import ReceiptVoucherViewPage
    from "../transactions/receipt_voucher/pages/ReceiptVoucherViewPage";

import ReceiptVoucherEditPage
    from "../transactions/receipt_voucher/pages/ReceiptVoucherEditPage";

import ContraVoucherListPage
  from "../transactions/contra_voucher/pages/ContraVoucherListPage";

import ContraVoucherCreatePage
  from "../transactions/contra_voucher/pages/ContraVoucherCreatePage";

import ContraVoucherViewPage
  from "../transactions/contra_voucher/pages/ContraVoucherViewPage";

import ContraVoucherEditPage
  from "../transactions/contra_voucher/pages/ContraVoucherEditPage";

import PayablesListPage
  from "../transactions/payables/pages/PayablesListPage";


import ReceivablesListPage
  from "../transactions/receivables/pages/ReceivablesListPage";

import VendorLedgerPage
  from "../reports/vendor_ledger/pages/VendorLedgerPage";

import CustomerLedgerPage
  from "../reports/customer_ledger/pages/CustomerLedgerPage";

// ======================================================================
// COMPONENT
// ======================================================================

export default function FinanceRoutes() {

  return (

    <FinanceLayout>

      <Routes>

        {/* ==========================================================
            DEFAULT
        ========================================================== */}

        <Route
          path="/"
          element={
            <Navigate
              to="dashboard"
              replace
            />
          }
        />


        {/* ==========================================================
            DASHBOARD
        ========================================================== */}

        <Route
          path="dashboard"
          element={
            <FinanceDashboardPage />
          }
        />


        {/* ==========================================================
            MANUAL JOURNAL - LIST
        ========================================================== */}

        <Route
          path="manual-journal"
          element={
            <ManualJournalListPage />
          }
        />

       {/* ==========================================================
            PAYMENT VOUCHER - LIST
        ========================================================== */}

        <Route
          path="payment-vouchers"
          element={
            <PaymentVoucherListPage />
          }
        />

        <Route
          path="payment-vouchers/create"
          element={
            <PaymentVoucherCreatePage />
          }
        />

        <Route
            path="/payment-vouchers/view/:id"
            element={
                <PaymentVoucherViewPage />
            }
        />
        <Route
            path="payment-vouchers/edit/:id"
            element={
                <PaymentVoucherEditPage />
            }
        />
            {/* ==========================================================
                        Receipt voucher
                    ========================================================== */}
                   {/* ==========================================================
    RECEIPT VOUCHER - LIST
========================================================== */}

<Route
    path="receipt-vouchers"
    element={
        <ReceiptVoucherListPage />
    }
/>

{/* ==========================================================
    RECEIPT VOUCHER - CREATE
========================================================== */}

<Route
    path="receipt-vouchers/create"
    element={
        <ReceiptVoucherCreatePage />
    }
/>

{/* ==========================================================
    RECEIPT VOUCHER - VIEW
========================================================== */}

<Route
    path="receipt-vouchers/view/:id"
    element={
        <ReceiptVoucherViewPage />
    }
/>

{/* ==========================================================
    RECEIPT VOUCHER - EDIT
========================================================== */}

<Route
    path="receipt-vouchers/edit/:id"
    element={
        <ReceiptVoucherEditPage />
    }
/>
  
  
  
{/* ==========================================================
    CONTRA VOUCHER
========================================================== */}


<Route
  path="contra-vouchers"
  element={
    <ContraVoucherListPage />
  }
/>

<Route
  path="contra-vouchers/create"
  element={
    <ContraVoucherCreatePage />
  }
/>
<Route
  path="contra-vouchers/view/:id"
  element={
    <ContraVoucherViewPage />
  }
/>  
  <Route
    path="contra-vouchers/edit/:id"
    element={
        <ContraVoucherEditPage />
    }
/>
        {/* ==========================================================
            MANUAL JOURNAL - CREATE
        ========================================================== */}

        <Route
          path="manual-journal/create"
          element={
            <JournalCreatePage />
          }
        />


        {/* ==========================================================
            MANUAL JOURNAL - VIEW
        ========================================================== */}

        <Route
          path="manual-journal/view/:id"
          element={
            <JournalViewPage />
          }
        />


        {/* ==========================================================
            MANUAL JOURNAL - EDIT
        ========================================================== */}

        <Route
          path="manual-journal/edit/:id"
          element={
            <JournalEditPage />
          }
        />
      {/* ==========================================================
            GENERAL LEDGER
        ========================================================== */}
       <Route
          path="reports/general-ledger"
          element={
              <GeneralLedgerPage />
          }
      />   
      
      {/* ==========================================================
            TRIAL BALANCE
        ========================================================== */}

        <Route
            path="reports/trial-balance"
            element={
                <TrialBalancePage />
            }
        />
        {/* ==========================================================
              PROFIT & LOSS
          ========================================================== */}

          <Route
            path="reports/profit-loss"
            element={
              <ProfitLossPage />
            }
          />

          {/* ==========================================================
                CASH FLOW
            ========================================================== */}

            <Route
                path="reports/cash-flow"
                element={
                    <CashFlowPage />
                }
            />

          {/* ==========================================================
              Balance Sheet
          ========================================================== */}

          <Route
            path="reports/balance-sheet"
             element={<BalanceSheetPage />}
          />
        {/* ==========================================================
            Payables workbench
        ========================================================== */}

          <Route
            path="payables"
            element={
              <PayablesListPage />
            }
          />  
        
            
        {/* ==========================================================
            RECEIVABLES WORKBENCH
        ========================================================== */}

        <Route
          path="receivables"
          element={
            <ReceivablesListPage />
          }
        />
          
          {/* ==========================================================
              VENDOR LEDGER
          ========================================================== */}

          <Route
            path="reports/vendor-ledger"
            element={
              <VendorLedgerPage />
            }
          />
          {/* ==========================================================
                CUSTOMER LEDGER
            ========================================================== */}

            <Route
              path="reports/customer-ledger"
              element={
                <CustomerLedgerPage />
              }
            />
        {/* ==========================================================
            FALLBACK
        ========================================================== */}

        <Route
          path="*"
          element={
            <Navigate
              to="/finance/dashboard"
              replace
            />
          }
        />

      </Routes>

    </FinanceLayout>

  );

}